import React from 'react';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import Modal from 'components/shared/Modal';
import FormTitle from 'components/shared/Typography/FormTitle';

const Confirm = ({
  title = 'Are you sure?',
  hint,
  hintBottom,
  children,
  theme = 'primary',
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
  onClose,
}) => (
  <Modal
    isOpen
    toClose={onClose}
    children={
      <>
        <FormTitle size="small" hint={hint} hintBottom={hintBottom} center>
          {title}
        </FormTitle>
        {children}
        <FormActions isCenter>
          <Button type="default" onClick={onClose} children={cancelButtonText} />

          <Button
            type={theme}
            htmlType="button"
            children={confirmButtonText}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          />
        </FormActions>
      </>
    }
  />
);

export default Confirm;
